// Lainakortin tekstit
export const resultCard = {
  nappula: 'Hae luotto',
}
export const paths = {
  loans: '/vertaa', //
  reviews: '/lainapalvelut', //
}
